module.exports = __webpack_public_path__ + "static/media/deepbio_logo.83fc8d59.svg";